import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IRouteOperationRequirementD365 {
    dataAreaId: string;
    operationNumber: number;
    routeId: string;
    routeOperationId: string;
    productionSiteId: string;
    itemNumber: string;
    willJobSchedulingUseRequirement: string;
    willOperationSchedulingUseRequirement: string;
    requiredOperationsResourceGroupId: string;
    requiredOperationsResourceId: string;
    requiredCapabilityName: string;
}

export const getRouteOperationRequirementsByRouteD365 = async (
    routeId: string,
    dataAreaId: string,
): Promise<IRouteOperationRequirementD365[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IRouteOperationRequirementD365[]>(
        `/RouteOperation/GetRouteOperationRequirementsByRouteD365`,
        { params: { routeId, dataAreaId } },
    );
    return response.data ?? [];
};
